import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {
  defaultPronounSetForGender,
  genderRequiresPronounSelection,
  PRONOUN_SET_OPTIONS,
  PronounSet,
  TicketGender,
} from '../../utils/ticketGenderPronouns';

interface GenderPronounFieldsProps {
  gender: TicketGender;
  pronounSet: PronounSet;
  onGenderChange: (gender: TicketGender, pronounSet: PronounSet) => void;
  disabled?: boolean;
  genderLabel?: string;
}

const GenderPronounFields: React.FC<GenderPronounFieldsProps> = ({
  gender,
  pronounSet,
  onGenderChange,
  disabled = false,
  genderLabel = 'Gender (Optional)',
}) => {
  const handleGenderChange = (event: SelectChangeEvent) => {
    const nextGender = event.target.value as TicketGender;
    if (!nextGender) {
      onGenderChange('', '');
      return;
    }
    onGenderChange(nextGender, defaultPronounSetForGender(nextGender));
  };

  const handlePronounChange = (event: SelectChangeEvent) => {
    onGenderChange(gender, event.target.value as PronounSet);
  };

  const showPronouns = gender !== '';
  const pronounEditable = genderRequiresPronounSelection(gender);

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="ticket-gender-label">{genderLabel}</InputLabel>
        <Select
          labelId="ticket-gender-label"
          value={gender}
          label={genderLabel}
          onChange={handleGenderChange}
          disabled={disabled}
        >
          <MenuItem value="">Not specified</MenuItem>
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </Select>
      </FormControl>
      {showPronouns && (
        <FormControl fullWidth required={pronounEditable}>
          <InputLabel id="ticket-pronoun-label">
            {pronounEditable ? 'Pronouns' : 'Pronouns (auto-selected)'}
          </InputLabel>
          <Select
            labelId="ticket-pronoun-label"
            value={pronounSet}
            label={pronounEditable ? 'Pronouns' : 'Pronouns (auto-selected)'}
            onChange={handlePronounChange}
            disabled={disabled || !pronounEditable}
          >
            {PRONOUN_SET_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default GenderPronounFields;
